// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ti-0";
export var checkoutRateBadgeLink = "_ti-1";